export enum GrievanceNotificationStatusEnum {
    completa = 2,
    pendente = 1,
}